export const getFaqData = (t) => [
  {
    id: 'faq-1',
    title: t('supplierRewardsProgramLearnMoreModal.faq.items.question1.title'),
    content: t(
      'supplierRewardsProgramLearnMoreModal.faq.items.question1.content',
    ),
  },
  {
    id: 'faq-2',
    title: t('supplierRewardsProgramLearnMoreModal.faq.items.question2.title'),
    content: t(
      'supplierRewardsProgramLearnMoreModal.faq.items.question2.content',
    ),
  },
  {
    id: 'faq-3',
    title: t('supplierRewardsProgramLearnMoreModal.faq.items.question3.title'),
    content: t(
      'supplierRewardsProgramLearnMoreModal.faq.items.question3.content',
    ),
  },
  {
    id: 'faq-4',
    title: t('supplierRewardsProgramLearnMoreModal.faq.items.question4.title'),
    content: t(
      'supplierRewardsProgramLearnMoreModal.faq.items.question4.content',
    ),
  },
]
